// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2fcb99ac] .artist-cover-image+.artist-section .section-hero .card-shadow{margin-top:-145px}@media(max-width: 1199.98px){[data-v-2fcb99ac] .artist-cover-image+.artist-section .section-hero .card-shadow{margin-top:-60px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
